import {
  ApiCartChangeCartPaymentModeRequestedAction,
  apiCartChangeCartPaymentModeFailed,
  apiCartChangeCartPaymentModeSucceeded
} from '../../../api/cart/changeCartPaymentModeApi';
import { call, put } from 'typed-redux-saga';
import changeCartPaymentModeAction, {
  ChangeCartPaymentModeActionInput,
  ChangeCartPaymentModeActionResult
} from '@spa/lib/actions/cart/changeCartPaymentModeAction';

function* changeCartPaymentModeSaga({
  payload: { actionId: requestedActionId, customOrderType, parentActionId, paymentMode }
}: ApiCartChangeCartPaymentModeRequestedAction): Generator {
  try {
    const input: ChangeCartPaymentModeActionInput = { customOrderType, paymentMode };
    const { cartId, result }: ChangeCartPaymentModeActionResult = yield* call(
      changeCartPaymentModeAction,
      'changeCartPaymentModeAction',
      input
    );
    yield* put(
      apiCartChangeCartPaymentModeSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartChangeCartPaymentModeFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default changeCartPaymentModeSaga;
